import React from "react";
import { AIConversationsForm } from "../../components";

const NewAIConversations = () => {
  return <AIConversationsForm></AIConversationsForm>;
};

export default NewAIConversations;
